import m from 'mithril';
import app from 'flarum/forum/app';
import LogInModal from 'flarum/forum/components/LogInModal';

/*
 * 手机端专用的轻量提示浮层。
 *
 * ============================================================
 * 为什么不用核心的 Modal（flarum/common/components/Modal）
 * ============================================================
 * Flarum 的 Modal 在窄屏（@media @phone）会把 .Modal-content 拉成
 * 「宽高接近整屏」，用来做登录框很合适，但做一句提示就太大了 ——
 * 实测在手机上几乎占满屏幕，改媒体查询也压不住核心的样式。
 *
 * 所以手机上改用这个自建浮层：宽度锁死、完全受控。
 * PC 端仍用核心 Modal（那里尺寸本来就合适），见 utils/guestGuard.js。
 *
 * 提示语由调用方传入（NOTICE 常量在 utils/guestGuard.js），
 * 避免两个模块互相 import 形成循环依赖。
 *
 * 【1.8.36.4】底部由单独一个「我知道了」改成
 *   「我知道了」(次要) + 「注册 / 登录」(主)
 * 点后者关掉浮层再拉起 LogInModal —— Flarum 没有独立 /login 页面，
 * 登录就是那个弹窗，手机上它接近整屏，等于"跳到登录界面"。
 */

let root = null;

function close() {
  if (!root) return;

  try {
    m.mount(root, null);
  } catch (e) {
    // ignore
  }

  if (root.parentNode) {
    root.parentNode.removeChild(root);
  }

  root = null;
}

/*
 * 关掉浮层再开登录弹窗。
 * 浮层是自建 DOM、没有淡出动画，但 mithril 卸载和核心 Modal 的挂载
 * 放在同一帧会互相抢焦点，给一帧的余量更稳。
 */
function goLogin() {
  close();

  setTimeout(() => {
    try {
      app.modal.show(LogInModal);
    } catch (e) {
      try {
        window.location.href = '/';
      } catch (e2) {
        // ignore
      }
    }
  }, 120);
}

const Layer = {
  view() {
    return m(
      'div.AcmeGuestNoticeLayer-mask',
      {
        onclick: (e) => {
          // 只点遮罩本身才关闭，点卡片不关
          if (e.target === e.currentTarget) close();
        },
      },
      m('div.AcmeGuestNoticeLayer-card', [
        m('div.AcmeGuestNoticeLayer-title', '暂时无法查看帖子内容'),
        m('div.AcmeGuestNoticeLayer-text', Layer.text),
        m('div.AcmeGuestNoticeLayer-actions', [
          m(
            'button.AcmeGuestNoticeLayer-ok',
            {
              type: 'button',
              onclick: close,
            },
            '我知道了'
          ),
          m(
            'button.AcmeGuestNoticeLayer-login',
            {
              type: 'button',
              onclick: goLogin,
            },
            '注册 / 登录'
          ),
        ]),
      ])
    );
  },
};

export function isGuestNoticeLayerOpen() {
  return !!root;
}

export function showGuestNoticeLayer(text) {
  Layer.text = text || '';

  if (root) {
    m.redraw();
    return;
  }

  root = document.createElement('div');
  root.className = 'AcmeGuestNoticeLayer';
  document.body.appendChild(root);

  m.mount(root, Layer);
}

export function closeGuestNoticeLayer() {
  close();
}
